export default function getResource(label, vars = []) {
    const resources = {
        title: 'Nos boutiques de créateurs ne sont pas disponibles dans votre région.',
        subTitle: 'Cette page est uniquement accessible depuis les États Unis à ce jour.',
        ctaText: 'Poursuivre votre visite',
        linkText: 'Voir les sites web internationaux de Sephora'
    };

    return resources[label];
}
